<template>
  <v-menu bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" plain icon>
        <CountryFlag :country="flagMap(currentLocale)" size="normal"/>
        <v-icon small>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list nav dense>
      <v-list-item-group v-model="activeLocale">
        <v-list-item v-for="(lang, key) in locales" :key="key" @click="update(lang)">
          <v-list-item-title>
            <v-icon small>{{ isActive(lang) ? 'mdi-chevron-right' : 'mdi-circle-small' }}</v-icon>
            <v-avatar size="20"><CountryFlag :country="flagMap(lang)" size="small"/></v-avatar>
            {{ $t(`languages.${lang}`) }}
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import LocalStorage from 'Store/class/local_storage'
import CountryFlag from 'vue-country-flag'
import VueCookies from 'vue-cookies'

export default {
  name: 'toolbar-lang-menu',
  components: { CountryFlag },
  data () {
    return {
      activeLocale: 0,
      currentLocale: 'en-US',
      locales: this.$i18n.availableLocales
    }
  },
  mounted () {
    const storageLocale = LocalStorage.getLocale()
    this.currentLocale = storageLocale
    if (this.locales.includes(storageLocale)) {
      this.update(storageLocale)
      this.activeLocale = this.locales.indexOf(storageLocale)
    }
  },
  methods: {
    update: function (locale) {
      this.$i18n.locale = locale
      this.currentLocale = locale
      VueCookies.set('locale', locale)
      LocalStorage.setLocale(locale)
    },
    isActive: function (locale) {
      return this.$i18n.locale === locale
    },
    flagMap (lang) {
      const map = {
        'fr-CA': 'ca',
        'en-US': 'us',
        'en-AU': 'au',
        'en-GB': 'gb'
      }
      return map[lang] || ''
    }
  }
}
</script>

<style scoped>
</style>
